import type { ReactNode } from 'react';
import { Col } from '../col';
import { Row } from '../row';
import { Text } from '../typography';

type P = {
  category: string;
  description?: string;
  icon: ReactNode;
  name: string;
};

const DetailsCategoryItem = ({ category, description, icon, name }: P) => (
  <Row align="middle" className="details-category-item" gutter={['ms', 'xs']}>
    <Col span={24}>
      <Text size="small" type="title" uppercase weight="medium">
        {category}
      </Text>
    </Col>
    <Col className="details-category-item__icon-wrapper" justifyContent="center">
      {icon}
    </Col>
    <Col flex="1">
      <Row>
        <Col span={24}>
          <Text type="title" weight="medium">
            {name}
          </Text>
        </Col>
        {description ? (
          <Col span={24}>
            <Text size="small">{description}</Text>
          </Col>
        ) : null}
      </Row>
    </Col>
  </Row>
);

export default DetailsCategoryItem;
